<template>
  <div class="VaelgDato">
    <!-- <h1>{{ $t('afrejsedato') }}</h1> -->
    <h1>{{ $t('ankomstdatotekst') }} <span class="circle-sketch-highlight">{{ $t('afrejseOverskrift') }}?  </span></h1>
    <!-- <p>Locale: {{ locale }}</p> -->
      <div class="datovalg">
        <datePicker :hotelPostnr='this.$route.params.postnr' endDate=1 v-bind:earliestDate=this.earliestDate @valgtDato="handleValgtSlutDato" />
      </div>

    <div class="Valg">
        <!-- <p>Indhold af cart: {{this.$store.getters.bookingInProgress}}</p> -->
    </div>

    <a v-on:click="navigateBack()">
      <div class="tilbage">
          <p>&#171; {{$t('tilbagetekst')}}</p>
      </div>
    </a>    

  </div>
</template>

<script>
import datePicker from '@/components/datePicker.vue'
import i18n from '@/plugins/i18n';
var moment = require('moment');
moment.locale('da');

export default {
  name: 'App',
  data () {
    return {
      valgtHotel: {},
      item: {"test": 2},
      earliestDate: '',
      locale: i18n.locale,
    }
  },
  components: {
    datePicker
  },
  created() {
    // Hvis der ikke er sat en startdate - så redirect til /startdato
    if(this.$store.getters.bookingInProgress.startdate === '0000-00-00') {
      this.$router.push({path: `startdato`});
    }

    if(this.$store.getters.bookingInProgress.roomtype == 'ekstra') {
      //this.$router.push({name: '6-ekstra'});
    }
    // Start med at nulstille tidligere valgt slutdato
    this.nulstil();
    // Det skal tidligst være muligt at vælge dagen efter ankomstdagen som slutdato
    this.earliestDate = moment.utc(this.$store.getters.bookingInProgress.startdate).add(1, 'days');
  },
  methods: {
      // Nulstiller slutdato - kaldes ved sideload, så frem/tilbagenavigering ikke gemmer tidligere indtastet data.
      nulstil() {
        var name = 'enddate';
        var value = '0000-00-00';
        console.log('Sætter '+name+': '+value);
        this.$store.dispatch("addToCart", {name, value});
      },
      handleValgtSlutDato(slutdato) {
        var name = 'enddate';
        var value = slutdato;
        console.log('Sætter '+name+': '+value);
        this.$store.dispatch("addToCart", {name, value});
        var roomtype = this.$store.getters.bookingInProgress.roomtype;
        //this.$router.push({name: '5-vaelgType', params: {hotel: this.$store.getters.bookingInProgress.hotel, checkin: this.$store.getters.bookingInProgress.startdate, checkout: this.$store.getters.bookingInProgress.enddate} }); // Send brugeren videre til næste side
        var url = '/'+this.locale+'/'+this.$route.params.koncern+'/vaerelsestype/'+roomtype+'/hotel/'+this.$route.params.postnr+'/checkin/'+this.$store.getters.bookingInProgress.startdate+'/checkout/'+this.$store.getters.bookingInProgress.enddate;
        console.log('Sender brugeren til '+url);
        this.$router.push({path: `/${this.locale}/${this.$route.params.koncern}/vaerelsestype/${roomtype}/hotel/${this.$route.params.postnr}/checkin/${this.$store.getters.bookingInProgress.startdate}/checkout/${this.$store.getters.bookingInProgress.enddate}`}); // Send brugeren videre til næste side
      },
      navigateBack() {
        //var backPath = "hotel/" + this.$store.getters.bookingInProgress.hotel;
        //this.$router.push({ path: backPath });
        this.$router.push({path: `/${this.locale}/${this.$route.params.koncern}/hotel/${this.$route.params.postnr}/startdato`});
      },
  },

}
</script>

<style scoped>
h1 {
  font-size: 400%;
  margin-bottom: 120px;
}

a {
  text-decoration: none;
}

.circle-sketch-highlight{
  position:relative;
  left:0.5em;
  /* font-family: Libre Franklin;
  font-size: 32px;
  font-weight: 500; */
}
.circle-sketch-highlight:before{
  content:"";
  z-index:-1;
  left:-0.5em;
  top:-0.1em;
  border-width:9px;
  border-style:solid;
  /* border-color:#ef8c22; */
  /* border-color:#3293c0; */
  border-color:#80c928;
  position:absolute;
  border-right-color:transparent;
  width:100%;
  height:1em;
  transform:rotate(2deg);
  opacity:0.7;
  border-radius:50%;
  padding:0.1em 0.25em;
}
.circle-sketch-highlight:after{
  content:"";
  z-index:-1;
  left:-0.5em;
  top:0.1em;
  padding:0.1em 0.25em;
  border-width:9px;
  border-style:solid;
  /* border-color:#ef8c22; */
  /* border-color:#3293c0; */
  border-color: #80c928;
  border-left-color:transparent;
  border-top-color:transparent;
  position:absolute;
  width:100%;
  height:1em;
  transform:rotate(-1deg);
  opacity:0.7;
  border-radius:50%;
}

.tilbage {
    text-transform: none;
    cursor: pointer;
    color: black;
}

/* når viewport er mindre end 960 px */
@media (max-width: 959px) {
  h1 {
    font-size: 200%;
    margin-bottom: 50px;
  }
}

</style>
